// Online payment is closed: checkout places the cart as an order and the
// sales team contacts the customer to arrange payment.
export function placeOrder(post) {
    return post('order/place', {})
        .then((response) => ({ ok: true, orderId: response.data.orderId }))
        .catch((err) => {
            const res = err && err.response;
            if (res && res.status === 403) return { ok: false, reason: 'email' };
            const message = res && typeof res.data === 'string' ? res.data : 'Oops! A problem occured';
            return { ok: false, reason: 'other', message };
        });
}
